import ManagePumpingSystemTable from './ManagePumpingSystemTable'

const ManagePumpingSystemType = {
  Table: ManagePumpingSystemTable,
}

export default ManagePumpingSystemType
